import script from "./AdvertisingCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvertisingCarousel.vue?vue&type=script&setup=true&lang=js"

import "./AdvertisingCarousel.vue?vue&type=style&index=0&id=49f9b1b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49f9b1b4"]])

export default __exports__